import { render } from "./InterventionGuideModal.vue?vue&type=template&id=6a5ab01f"
import script from "./InterventionGuideModal.vue?vue&type=script&lang=js"
export * from "./InterventionGuideModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/InterventionGuideModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a5ab01f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a5ab01f', __exports__)) {
    api.reload('6a5ab01f', __exports__)
  }
  
  module.hot.accept("./InterventionGuideModal.vue?vue&type=template&id=6a5ab01f", () => {
    api.rerender('6a5ab01f', render)
  })

}


export default __exports__